export default "__VITE_ASSET__Ccoz2DyY__"